import React from 'react';
import { Box } from '@mui/material';

const managementActions = [
  { icon: '⚠', color: 'red', title: '3 High-risk suppliers', desc: 'XYZ Chemicals, HealthCorp, Vedica Store need review' },
  { icon: '📋', color: 'blue', title: '47L pending savings', desc: '3 vendor contracts awaiting final sign-off' },
  { icon: '📊', color: 'teal', title: 'Vendor score improved', desc: 'Avg score ▲ 3 pts to 82/100 this quarter' },
  { icon: '🎯', color: 'purple', title: 'OTIF trending up', desc: 'Supplier OTIF ▲ 2.1 pts to 87.4%' },
];

export default function ManagementActionCenterCard() {
  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Action Center</h3>
      </div>
      <div className="alert-list" style={{ height: '220px', overflow: 'auto' }}>
        {managementActions.map((action, i) => (
          <Box key={i} className="alert-item">
            <Box
              className={`alert-icon ${action.color === 'red' ? 'crit' : action.color === 'blue' ? 'info' : action.color === 'teal' ? 'info' : 'warn'}`}
              style={{ background: `var(--${action.color}-bg)`, color: `var(--${action.color})` }}
            >
              {action.icon}
            </Box>
            <Box className="alert-text">
              <b>{action.title}</b>
              <div className="alert-time">{action.desc}</div>
            </Box>
          </Box>
        ))}
      </div>
    </Box>
  );
}
